// extracted by mini-css-extract-plugin
var _1 = "MobileElement_answers__5e382";
var _2 = "MobileElement_groups__0b2fb";
var _3 = "MobileElement_root__832ab";
var _4 = "MobileElement_tableView__0b1a8";
export { _1 as "answers", _2 as "groups", _3 as "root", _4 as "tableView" }
